import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { useIsMounted } from 'utils/hooks/useIsMounted';
import { useTranslation } from 'utils/modifiedTranslation';
import styles from './phoneIsAlreadyUsed.module.css';
import copyIconSrc from './copy.svg';

const SHOW_TOOLTIP_TIME = 3000;

export const CopyButton = ({ onClick }) => {
  const { t } = useTranslation();
  const [isTooltipShown, setIsTooltipShown] = useState(false);
  const isMounted = useIsMounted();
  const timeoutRef = useRef(null);

  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  return (
    <Tooltip
      title={t('phone_is_used_popup.copied_tooltip')}
      open={isTooltipShown}
    >
      <button
        type="button"
        className={styles.copyButton}
        onClick={() => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            timeoutRef.current = null;
            if (!isMounted()) {
              return;
            }
            setIsTooltipShown(false);
          }, SHOW_TOOLTIP_TIME);
          setIsTooltipShown(true);
          onClick();
        }}
      >
        <img alt="button icon" src={copyIconSrc} className={styles.copyIcon} />
      </button>
    </Tooltip>
  );
};

CopyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
